
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {IStorageLayerDeliveryNoteInfoModel, IStorageModel} from "@/api/types";
import {
  CustomsPacking,
  HqPackingListDetail,
  TableRowData,
  BulkProductTableRowData,
} from "@/model/HqPackingListModels";
import {
  InventoryPlans,
  HqPackingList,
  UnpackedProductInfos,
  CustomsPackingSet,
  CustomsPackingState,
} from "@/model/inventory-plan";
import {updateProductQuantity} from "@/api/customs-packing";

import {
  historyProblemCustomsPacking,
  confirmCustomsPacking,
} from "@/api/inventory-plan";
import HistoryTable from "./HistoryTable.vue";

@Component({
  name: "HistoryProblem",
  components: {
    Pagination,
    HistoryTable,
  },
})
export default class extends Vue {
  @Prop({required: true}) private data: HqPackingList;
  @Prop({required: false, default: false}) private show: boolean;
  @Prop({required: false, default: false}) private code: string;
  @Prop({required: false, default: false}) private title: string;
  @Prop({required: false, default: false}) private stateName: string;
  @Prop({required: false, default: false}) private inventoryPlanId: string;
  private data_: HqPackingList = new HqPackingList();
  private customsPackingSetFlag = false;

  @Watch("data", {deep: true, immediate: true})
  private watchData() {
    this.data_ = this.data;
  }

  @Watch("show", {deep: true, immediate: true})
  private watchShow() {
    this.data_ = this.data;
    if (this.show) {
      this.getList();
    }
  }

  private open() {
    this.$emit("update:show", true);
  }

  private close() {
    this.$emit("update:show", false);
  }

  private listLoading = false;
  private hqPackingListDetail: HqPackingListDetail = new HqPackingListDetail();

  private async getList() {
    const res: any = await historyProblemCustomsPacking(this.data.id, {
      customsPackingState: this.stateName,
    });
    this.hqPackingListDetail.customsPackingSet = res;
    this.customsPackingSetFlag = true;
  }
}
